// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3618P","header":"PatientQuestionnaire_header__2YF2B","info":"PatientQuestionnaire_info__hYV6Q"};